import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "theme/ThemeProvider";

import { App } from "./components/App/App";
import { CustomOidcProvider } from "./components/Login/providers/CustomOidcProvider";
import { ErrorFallback } from "./components/common/ErrorFallback";
import "./index.less";
import PostHogProviderWrapper from "./postHogProviderWrapper";
import reportWebVitals from "./reportWebVitals";
import { SentryMonitor } from "./sentry";
import "./tailwind.css";

(async () => {
  const LDProvider = await asyncWithLDProvider({
    // TODO ENG-2130 do not leak configuration - load LD entirely from backend
    clientSideID:
      window?.location.hostname === "p0.app"
        ? "644178eaf2d05912f9c32810"
        : window?.location.hostname === "cna.p0.app" // prod-cna-central environment
          ? "664249465ed4bd0f93c426d5"
          : window?.location.hostname === "splunk-nonprod.p0.app" // prod-splunk-nonprod environment
            ? "67055ebeb60325083684bee2"
            : window?.location.hostname === "splunk.p0.app" // prod-splunk-live environment
              ? "670eb9a11abc32082c48f4c9"
              : window?.location.hostname === "demo.p0.app" // prod-demo environment
                ? "683f55fc9723130dc1a539d0"
                : "644178eaf2d05912f9c3280f",
    options: {
      streaming: true,
    },
  });
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <SentryMonitor>
          <LDProvider>
            <PostHogProviderWrapper>
              <CustomOidcProvider>
                <ThemeProvider>
                  <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <App />
                  </ErrorBoundary>
                </ThemeProvider>
              </CustomOidcProvider>
            </PostHogProviderWrapper>
          </LDProvider>
        </SentryMonitor>
      </BrowserRouter>
    </React.StrictMode>
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
